import { useState } from "react";
import { api, apiError } from "../lib/api";
import { ChipGroup } from "./fields";
import { X } from "lucide-react";
import { toast } from "sonner";

export default function CommSheet({ student, onClose, onSaved }) {
  const [form, setForm] = useState({ communicated_with: "", mode: "In person", summary: "", follow_up: "" });
  const [saving, setSaving] = useState(false);
  const set = (k) => (v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async () => {
    if (!form.communicated_with || !form.summary) { toast.error("Fill in who and summary"); return; }
    setSaving(true);
    try {
      await api.post("/comm-logs", { ...form, student_id: student.id, date: new Date().toISOString().slice(0, 10) });
      toast.success("Communication logged");
      onSaved();
    } catch (e) { toast.error(apiError(e)); }
    setSaving(false);
  };

  return (
    <div className="fixed inset-0 z-50 bg-slate-900/50 sf-overlay flex items-end sm:items-center justify-center" onClick={onClose}>
      <div data-testid="comm-sheet" className="sf-sheet bg-white w-full sm:max-w-lg sm:rounded-2xl rounded-t-2xl max-h-[92vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="sticky top-0 bg-white border-b border-slate-100 px-5 py-4 flex items-center justify-between">
          <div>
            <h2 className="font-heading font-semibold text-slate-900">Log Communication</h2>
            <p className="text-xs text-slate-400">{student.first_name} {student.last_name}</p>
          </div>
          <button data-testid="close-comm-sheet-btn" onClick={onClose} className="p-2 text-slate-400 hover:text-slate-700"><X size={18} /></button>
        </div>
        <div className="p-5 space-y-4">
          <div>
            <label className="text-xs font-bold tracking-[0.06em] uppercase text-slate-500">Communicated with</label>
            <input data-testid="comm-with-input" value={form.communicated_with} onChange={(e) => set("communicated_with")(e.target.value)}
              placeholder="e.g., Classroom Teacher (Ms. Lopez)" className="mt-1 w-full rounded-md border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-600" />
          </div>
          <ChipGroup label="Mode" options={["In person", "Email", "Phone", "Message"]} value={form.mode} onChange={set("mode")} testPrefix="comm-mode" />
          <div>
            <label className="text-xs font-bold tracking-[0.06em] uppercase text-slate-500">Summary</label>
            <textarea data-testid="comm-summary-input" value={form.summary} onChange={(e) => set("summary")(e.target.value)} rows={3}
              className="mt-1 w-full rounded-md border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-600" />
          </div>
          <div>
            <label className="text-xs font-bold tracking-[0.06em] uppercase text-slate-500">Follow-up actions</label>
            <input data-testid="comm-followup-input" value={form.follow_up} onChange={(e) => set("follow_up")(e.target.value)}
              className="mt-1 w-full rounded-md border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-600" />
          </div>
          <button data-testid="submit-comm-btn" onClick={submit} disabled={saving}
            className="w-full bg-emerald-700 hover:bg-emerald-800 text-white font-semibold rounded-full py-3 text-sm transition-colors duration-150 active:scale-[0.98] disabled:opacity-60">
            {saving ? "Saving…" : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
}
